import _isEmpty from 'underscore/cjs/isEmpty.js'

export const useIncomeProtectionStore = defineStore('income-protection', {
  state: () => ({
    form: {}
  }),

  getters: {
    leadParams () {
      const form = this.form

      if (_isEmpty(form)) {
        return {}
      }

      const utmsStore = useUtmsStore()
      const formData = flattenObj(form, 1)

      const obj = {
        ...getName(formData?.full_name),
        age: formData?.age,
        salary: formData?.annual_income.replace(/[$,]/g, ''),
        smoker: formData?.smoker,
        gender: formData?.gender,
        occupation: form?.occupation?.id,
        occupationList: form?.occupation?.name,
        occupation_omni_id: form?.occupation?.omniumId,
        state: formData.state,
        phone: formData.phone,
        email: formData.email,

        brand: 'CC',
        form_page: import.meta.client && window.location.href,
        landing_page: utmsStore.GET_UTMS_LANDING_PAGE,
        trauma_sum_insured: formData.trauma_sum_insured ?? 0,
        tpd_sum_insured: formData.tpd_sum_insured ?? 0,
        benefit_period: formData.benefit_period ?? '2 years',
        waiting_period: formData.waiting_period ?? '90 days',
        viewed_quotes: formData.viewed_quotes ?? 'yes',
        guide_form_access: formData.guide_form_access ?? 'yes'
      }

      return obj
    }
  },

  actions: {
    async createLead (payload) {
      const utmsStore = useUtmsStore()

      const response = await useFetch('/api/lead/create', {
        method: 'post',
        body: {
          vertical: 'Income Protection',
          ...utmsStore.utms,
          ...payload
        }
      }).then(res => {
        const temp = res?.data.value

        if (temp?.error) {
          throw temp?.error
        }

        const data = temp?.data

        return data?.lead_uuid ?? undefined
      }).catch(error => {
        throw error
      })

      return response
    }
  }
})
